import { Component, Input } from '@angular/core';

@Component({
  selector: 's-polaris-product-thumbnail',
  templateUrl: './s-polaris-product-thumbnail.component.html',
  styleUrls: ['./s-polaris-product-thumbnail.component.scss'],
  standalone: false,
})
export class PolarisProductThumbnailComponent {
  @Input() image = '';
  @Input() quantity?: number;
  @Input() size = 40;
}
